export default __webpack_public_path__ + "static/media/LPTL.d807fd2b.svg";